module.exports = __webpack_public_path__ + "static/stuart-parsons-46586b0628c363f29c863b397f031b7d.jpg";